$(function(){
  let snapPos = 0;
  let dealSnapPos = 0;

  $(window).on('scroll', function(e){
    // Mid Nav
    let midNavTop = 0;

    if( $('#topic-nav').length){
      midNavTop = $('#topic-nav').position().top - $('#topic-nav').height();
    }
    
    if(snapPos == 0) {
      if($(this).scrollTop() > (midNavTop + 20)) { // 20px padding on #topic-nav
        if( $('#topic-nav').length){
          snapPos = $('#topic-nav').position().top - $('#topic-nav').height();
        } else {
          snapPos = 0;
        }
        $('#topic-nav').addClass('main-nav-scrolled');
        $('#topic-nav-spacer').css('display', 'block');
        if(window.innerWidth > 767) {
          $('#deals-subnav').css('display', 'none');
        }
      }
    } else {
      if($(this).scrollTop() < snapPos ) {
        $('#topic-nav').removeClass('main-nav-scrolled');
        $('#topic-nav-spacer').css('display', 'none');
        if(window.innerWidth > 767) {
          $('#deals-subnav').css('display', 'block');
        }
        snapPos = 0;
      }
    }

    // New Deals sub-nav
    let dealNavTop = 0;

    if( $('#deals-subnav').length){
      dealNavTop = $('#deals-subnav').position().top;
    }
    
    if(dealSnapPos == 0) {
      if($(this).scrollTop() > dealNavTop) { // 20px padding on #topic-nav
        if( $('#deals-subnav').length){
          dealSnapPos = $('#deals-subnav').position().top - $('#deals-subnav').height();
        } else {
          dealSnapPos = 0;
        }
        $('#deals-subnav').addClass('snapped');
      }
    } else {
      if($(this).scrollTop() < dealSnapPos ) {
        $('#deals-subnav').removeClass('snapped');
        dealSnapPos = 0;
      }
    }

  });

});
